import React from 'react';
import { HtmlEditor } from './HtmlEditor';

export const CommentsEditor = props => (<HtmlEditor {...props} field="comments" />);
